import { handleActions, combineActions } from 'redux-actions';
import { fromJS, Map, List } from 'immutable';

import actions from '../actions';

//REDUCERS
const { step } = actions.customer;
export default handleActions(
  {
    [combineActions(step.next.toString(), step.change.toString(), step.prev.toString())]: (step, { payload }) => {
      //no tinc clar q sigui correcta
      return payload ? step.set('current_step', fromJS(payload)) : step;
    },
    [step.initialize.toString()]: (step, { payload }) => {
      return payload;
    }
  },
  Map({
    loaded: false,
    current_step: null,
    list: List()
  })
);
